// @flow

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Flex, Button } from 'clark-styles';

import { cancelSession } from 'actions/sessions';

import ModalAndTrigger from 'containers/modal-and-trigger';

import CancelButton from 'components/button-cancel';

import { type SessionType } from 'types/sessions';

import TimeIcon from 'assets/icons/time.svg';

import { SPACING_MEDIUM } from 'styles/spacing';

import { Copy, Headline, SubmitButton, Wrapper } from './styles';

type PassedInPropsType = {
  clientName: string,
  session: SessionType,
  disabled: boolean,
};

type DispatchPropsType = {
  dispatchCancelSession: typeof cancelSession,
};

type PropsType = PassedInPropsType & DispatchPropsType;

const mapDispatchToProps: DispatchPropsType = { dispatchCancelSession: cancelSession };

class SessionsCanceledModal extends Component<PropsType> {
  handleCancelSession = toggleModal => {
    const {
      session: { id: resourceId },
      dispatchCancelSession,
    } = this.props;

    dispatchCancelSession(resourceId);
    toggleModal();
  };

  render() {
    const { clientName, disabled } = this.props;
    return (
      <ModalAndTrigger
        modalContentLabel="Cancel-Session Modal"
        renderModalTrigger={toggleModal => (
          <Button
            layout="fullWidth"
            styleType="outlineSecondary"
            margin={`0 0 ${SPACING_MEDIUM}`}
            disabled={disabled}
            icon={<TimeIcon />}
            onClick={toggleModal}
          >
            Late Cancelation
          </Button>
        )}
        renderModalContent={toggleModal => (
          <Wrapper>
            <Flex justifyContent="space-between">
              <Headline>Are you sure?</Headline>
              <CancelButton onClick={toggleModal} />
            </Flex>
            <Copy>
              This session will be marked as canceled, and will appear on {clientName}
              ’s bill.
            </Copy>
            <Flex justifyContent="center">
              <SubmitButton
                type="button"
                onClick={() => this.handleCancelSession(toggleModal)}
                layout="fullWidth"
              >
                Mark as canceled
              </SubmitButton>
            </Flex>
          </Wrapper>
        )}
      />
    );
  }
}

export default connect(
  null,
  mapDispatchToProps,
)(SessionsCanceledModal);



// WEBPACK FOOTER //
// ./src/containers/sessions/canceled-modal/index.js